import { gql } from '@apollo/client';

export type Fields = {
  key: string;
  value: string;
};

export type PresignedUrl = {
  url: string;
  fields: Fields[];
  objectKey: string;
};

export enum StorageProvider {
  AWS_S3 = 'AWS_S3',
  AZURE_BLOB = 'AZURE_BLOB',
}

export type StartAvatarUpload = {
  uploadId: string;
  fileId: string;
  storageProvider: StorageProvider;
  presignedUrl: PresignedUrl;
};

export type StartUploadAvatarResponse = {
  startAvatarUpload: StartAvatarUpload;
};

export type AvatarUploadInput = {
  fileName: string;
  fileSize: number;
  fileType: string;
};

export const START_UPLOADING_AVATARS = gql`
  query StartUploadAvatarUrl($avatarUploadInput: AvatarUploadInput!) {
    startAvatarUpload(avatarUploadInput: $avatarUploadInput) {
      uploadId
      fileId
      storageProvider
      presignedUrl {
        url
        objectKey
        fields {
          key
          value
        }
      }
    }
  }
`;
